import React, { FC } from 'react';
import { IWizardProps, WizardPhase } from 'types/wizard';
import { Build, Customize, Integrate } from './Phases';
import WizardLayout from './Phases/WizardLayout';

const WizardPhasePage: FC<IWizardProps> = (props) => {
	const {
		state: { phase }
	} = props;

	let PhaseComponent = null;
	switch (phase) {
		case WizardPhase.Customize:
			PhaseComponent = Customize;
			break;
		case WizardPhase.Integrate:
			PhaseComponent = Integrate;
			break;
		case WizardPhase.Build:
			PhaseComponent = Build;
			break;
		case WizardPhase.Done:
			PhaseComponent = Customize;
			break;
		default:
			PhaseComponent = Build;
			break;
	}

	return (
		<WizardLayout phase={phase}>
			<PhaseComponent {...props} />
		</WizardLayout>
	);
};

export default WizardPhasePage;
